<template>
  <transition name="el-fade-in-linear">
    <div class="spinner" v-show="shown.divshow"></div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      shown: {
        divshow: true,
      },
    };
  },
  mounted() {
    document.title = this.$t("App.title.loading");
    this.toLogin();
  },
  methods: {
    toLogin() {
      setTimeout(() => {
        this.$router.push({ name: "Login" });
      }, 500);
    },
  },
};
</script>

<style scoped>
.spinner {
  width: 15rem;
  height: 15rem;
  margin-left: 50rem;
  margin-top: 20rem;
  background-color: #409eff;

  border-radius: 100%;
  -webkit-animation: scaleout 1s infinite ease-in-out;
  animation: scaleout 1s infinite ease-in-out;
}

@-webkit-keyframes scaleout {
  0% {
    -webkit-transform: scale(0);
  }
  100% {
    -webkit-transform: scale(1);
    opacity: 0;
  }
}

@keyframes scaleout {
  0% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/common/Loading.vue